//=include polyfills/Object.assign.js
//=include polyfills/closest.js
//=include polyfills/CustomEvent.js

//=require slick-carousel/slick/slick.min.js

//=include sifter/lib/sifter.js

//=include plugins/country-selection.js
//=include plugins/scroll-table.js
//=require plugins/multi-select.js
//=include plugins/quantity-control.js
//=include plugins/search.js
//=include plugins/move.js
//=include plugins/scenes.js
//=include plugins/sliding-accordion.js
//=require plugins/carousel.js
//=require plugins/fancy-grid.js
//=require plugins/popup-page.js
//=require plugins/video-block.js
//=require plugins/extraSlickOptions.js

//=include components/quantity-control.js
//=include components/multi-select.js
//=include components/search.js
//=include components/move.js
//=include components/scenes.js
//=include components/sliding-accordion.js
//=require components/carousel.js
//=require components/fancy-grid.js
//=require components/popup-page.js
//=require components/video-block.js
//=require components/hotspot.js

//=include aos/dist/aos.js

//=include tools/loop.js
//=include tools/svg.js
//=include tools/breakpoint.js

Astro.quantityControl();
Astro.multiSelect();
Astro.search();
Astro.move();
Astro.scenes();
Astro.slidingAccordions();
Astro.carousel();
Astro.fancyGrid();
Astro.popupPage();
Astro.video();
Astro.hotspotGallery();
Astro.hotspotGalleryTooltips();
Astro.hotspotGalleryProducts();

AOS.init({
    once: true,
    offset: 0
});

function easeOutQuint(x) {
    return 1 - Math.pow(1 - x, 5);
}

window.getParams = function(qs) {
    var params = {};

    if (qs === undefined) {
        qs = window.location.search;
    }

    if (qs) {
        var pairs = qs.replace('?', '').split('&');

        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            var k = pair[0];
            var v = decodeURIComponent(pair[1]);

            if (params[k]) {
                params[k] += ',' + v;
            } else {
                params[k] = v;
            }
        }
    }

    return params;
};

if (window.jQuery) {
    window.jQuery.getParams = window.getParams;
}

var ajax_response = 0;
var activeScrollAnimation = null;

function onReady(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}

function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
}

function query(selector, root) {
    return (root || document).querySelector(selector);
}

function queryAll(selector, root) {
    return toArray((root || document).querySelectorAll(selector));
}

function onEach(elements, eventName, handler, options) {
    toArray(elements).forEach(function(element) {
        element.addEventListener(eventName, handler, options);
    });
}

function delegate(root, eventName, selector, handler) {
    if (!root) {
        return;
    }

    root.addEventListener(eventName, function(event) {
        var matched = event.target.closest(selector);

        if (matched && (root === document || root === window || root.contains(matched))) {
            handler.call(matched, event, matched);
        }
    });
}

function getFormBody(form) {
    return new URLSearchParams(new FormData(form));
}

function fetchJson(url, options) {
    return fetch(url, options).then(function(response) {
        if (!response.ok) {
            throw new Error('Request failed with status ' + response.status);
        }

        return response.json();
    });
}

function fetchText(url, options) {
    return fetch(url, options).then(function(response) {
        if (!response.ok) {
            throw new Error('Request failed with status ' + response.status);
        }

        return response.text();
    });
}

function parseHtmlDocument(html) {
    return new DOMParser().parseFromString(html, 'text/html');
}

function buildUrl(url, params) {
    var requestUrl = new URL(url, window.location.origin);

    Object.keys(params || {}).forEach(function(key) {
        if (params[key] !== undefined && params[key] !== null) {
            requestUrl.searchParams.set(key, params[key]);
        }
    });

    return requestUrl.toString();
}

function replaceImageHtml(container, html) {
    if (!container) {
        return;
    }

    container.insertAdjacentHTML('afterbegin', html);

    var previousImage = container.querySelector('img:nth-of-type(2)');

    if (previousImage) {
        previousImage.style.transition = 'opacity 200ms';
        previousImage.style.opacity = 0;
        setTimeout(function() {
            previousImage.remove();
        }, 200);
    }
}

function waitForImages(images) {
    return Promise.all(images.map(function(image) {
        return new Promise(function(resolve) {
            if (image.complete) {
                resolve();
                return;
            }

            function done() {
                image.removeEventListener('load', done);
                image.removeEventListener('error', done);
                resolve();
            }

            image.addEventListener('load', done);
            image.addEventListener('error', done);
        });
    }));
}

function fadeIn(element, duration) {
    if (!element) {
        return;
    }

    element.style.display = '';
    element.style.opacity = 0;

    var start;

    function step(timestamp) {
        if (start === undefined) {
            start = timestamp;
        }

        var progress = Math.min((timestamp - start) / duration, 1);
        element.style.opacity = progress;

        if (progress < 1) {
            window.requestAnimationFrame(step);
        } else {
            element.style.opacity = '';
        }
    }

    window.requestAnimationFrame(step);
}

function stopWindowScrollAnimation() {
    if (activeScrollAnimation && activeScrollAnimation.frame) {
        window.cancelAnimationFrame(activeScrollAnimation.frame);
    }

    activeScrollAnimation = null;
}

function animateWindowScrollTo(top, duration) {
    stopWindowScrollAnimation();

    var startTop = window.pageYOffset;
    var distance = top - startTop;
    var startTime = null;
    var animation = {
        frame: null
    };

    activeScrollAnimation = animation;

    function step(timestamp) {
        if (activeScrollAnimation !== animation) {
            return;
        }

        if (startTime === null) {
            startTime = timestamp;
        }

        var progress = Math.min((timestamp - startTime) / duration, 1);
        var nextTop = startTop + (distance * easeOutQuint(progress));

        window.scrollTo(0, nextTop);

        if (progress < 1) {
            animation.frame = window.requestAnimationFrame(step);
        } else {
            activeScrollAnimation = null;
        }
    }

    animation.frame = window.requestAnimationFrame(step);
}

function setButtonDisabled(button, disabled) {
    if (!button) {
        return;
    }

    button.classList.toggle('button--disabled', disabled);
    button.disabled = disabled;
}

function triggerCustomEvent(element, eventName) {
    if (!element) {
        return;
    }

    element.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true
    }));
}

function setDisplay(element, visible) {
    if (!element) {
        return;
    }

    element.style.display = visible ? '' : 'none';
}

function getOuterHeight(element) {
    return element ? element.getBoundingClientRect().height : 0;
}

// function updateHeaderShadowState(force) {
//     if (999 > $(window).width()) {
//         return false;
//     }

//     if (!force) {
//         $('.header').removeClass('header--force');
//     }
// }

function searchEvent(location, value)
{
    var intRegex = /^\d+$/;
    var isInt = intRegex.test(value) ? true : false;
    var action;

    if (isInt && value.length == 7) {
        action = '7 digit';
    } else if (isInt && value.length == 4) {
        action = '4 digit';
    } else if (isInt) {
        action = 'digit - other';
    } else {
        action = 'other';
    }

    TRACKING.trackEvent(location, action, value);
}

onReady(function() {
    // Polyfill input placeholders
    // $('input[placeholder]').cleverlabels();

    // Replace selects with fancy selects
    // replaceSelects();

    // Prevent hash links from jumping to top
    onEach(queryAll("a[href='#']"), 'click', function(e) {
        e.preventDefault();
    });

    // Remove header transitions for initial render
    // $('.header').addClass('header--force');

    // // Set initial header state
    // updateHeaderShadowState(true);

    // // Add header shadow on scroll
    // $(window).scroll(function() {
    //     updateHeaderShadowState(false);
    // });

    // Enable locale switcher
    onEach(queryAll('select[name="locale"]'), 'change', function() {
        window.location.href = this.value;
    });

    onEach(queryAll('select.js-select-navigation'), 'change', function() {
        window.location.href = this.value;
    });

    // Some dodgy selectors, but we need to keep it dynamic in case there
    // are multiple instances of tabbed content on a page
    // window.switchTab = function(tabId, scrollTo, highlight) {
    //         var nav = $('.tabs a[href="' + tabId + '"]').parents('.tabs'),
    //             tab = $(tabId);

    //         highlight = typeof highlight == 'undefined'
    //             ? false
    //             : true;

    //         if (nav.length) {
    //             nav.find('.tabs__link').removeClass('tabs__link--active');
    //             nav.find('[href="' + tabId + '"]').addClass('tabs__link--active');

    //             if (tab.parents('.bg-icon').length) {
    //                 tab.parents('.bg-icon')
    //                     .toggleClass('bg-icon--hidden', typeof nav.find('[href="' + tabId + '"]').data('show-bg-icon') === 'undefined');
    //             }
    //         }

    //         tab.parent().find('.tabs__content').removeClass('tabs__content--active');
    //         tab.addClass('tabs__content--active');

    //         if (typeof scrollTo === 'boolean' && scrollTo) {
    //             $('body, html')
    //                 .animate({
    //                     scrollTop: tab.parents('.section:first').offset().top - $('.header-buffer').outerHeight()
    //                 }, 1000, 'easeOutQuint');
    //         }

    //         $(window).trigger('resize');
    //     };

    // $(document).on('click', '.tabs__link', function(e) {
    //     e.preventDefault();
    //     switchTab($(this).attr('href'));
    // });

    // $(document).on('click', '[data-switch-tab]', function(e) {
    //     e.preventDefault();
    //     switchTab($(this).attr('href'), true, $(this).data('highlight-tab'));
    // });

    // $('.tabs .tabs__link:first-child')
    //     .each(function(i, el) {
    //         window.switchTab(el.hash);
    //     });

    // Login button
    onEach(queryAll('[data-action="login"], [data-action="open-login-modal"]'), 'click', function(event) {
        event.preventDefault();

        var loginModal = query('.login-modal');
        var forgotPasswordModal = query('.forgot-password-modal');

        if (this.hasAttribute('data-restricted') && loginModal) {
            loginModal.classList.add('login-modal--restricted');
        }

        // Close forgot-password modal
        document.body.classList.remove('body--forgot-password-modal');
        if (forgotPasswordModal) {
            forgotPasswordModal.classList.remove('forgot-password-modal--activating', 'forgot-password-modal--active');
        }

        // Open login modal
        document.body.classList.add('body--login-modal');

        if (loginModal) {
            loginModal.classList.add('login-modal--activating');
        }

        setTimeout(function() {
            if (loginModal) {
                loginModal.classList.add('login-modal--active');
            }

            // Rerun dummy labels to fix dimensions
            var passwordInput = query('.login-modal .cleverpassword .input[name="password"]');
            var passwordField = query('.login-modal .field.password');
            var cleverPassword = query('.login-modal .cleverpassword');

            if (passwordInput && passwordField) {
                passwordField.appendChild(passwordInput);
            }

            if (cleverPassword) {
                cleverPassword.remove();
            }

            // $('.login-modal input[name="password"]').cleverlabels();

            var emailInput = query('.login-modal input[name="email"]');
            if (emailInput) {
                emailInput.focus();
            }
        }, 1);
    });

    // Login modal close
    onEach(queryAll('[data-action="close-login-modal"]'), 'click', function(event) {
        event.preventDefault();
        document.body.classList.remove('body--login-modal');

        var loginModal = query('.login-modal');

        if (loginModal) {
            loginModal.classList.remove('login-modal--active');
        }

        setTimeout(function() {
            if (loginModal) {
                loginModal.classList.remove('login-modal--activating');
            }
        }, 300);
    });

    // Password modal close
    onEach(queryAll('[data-action="close-forgot-password-modal"]'), 'click', function(event) {
        event.preventDefault();
        document.body.classList.remove('body--forgot-password-modal');

        var forgotPasswordModal = query('.forgot-password-modal');

        if (forgotPasswordModal) {
            forgotPasswordModal.classList.remove('forgot-password-modal--active');
        }

        setTimeout(function() {
            if (forgotPasswordModal) {
                forgotPasswordModal.classList.remove('forgot-password-modal--activating');
            }
        }, 300);
    });

    // Forgot password button
    onEach(queryAll('[data-action="forgot-password"], [data-action="open-forgot-password-modal"]'), 'click', function(event) {
        event.preventDefault();

        var loginModal = query('.login-modal');
        var forgotPasswordModal = query('.forgot-password-modal');
        var forgotMessage = query('.forgot-password-modal__form-message');

        // Close login modal
        document.body.classList.remove('body--login-modal');
        if (loginModal) {
            loginModal.classList.remove('login-modal--activating', 'login-modal--active');
        }

        // Hide/Remove message if we are re-opening this modal
        if (forgotMessage) {
            forgotMessage.innerHTML = '';
            forgotMessage.style.display = 'none';
            forgotMessage.style.opacity = '';
        }

        // Open forgot-password modal
        document.body.classList.add('body--forgot-password-modal');

        if (forgotPasswordModal) {
            forgotPasswordModal.classList.add('forgot-password-modal--activating');
        }

        setTimeout(function() {
            if (forgotPasswordModal) {
                forgotPasswordModal.classList.add('forgot-password-modal--active');
            }

            var emailInput = query('.forgot-password-modal input[name="email"]');
            if (emailInput) {
                emailInput.focus();
            }
        }, 1);
    });

    onEach(queryAll('.login-modal__form'), 'submit', function(e) {
        e.preventDefault();

        var form = this;
        var submit = form.querySelector('[type="submit"]');
        setButtonDisabled(submit, true);

        fetchJson(form.getAttribute('action'), {
            method: 'POST',
            body: getFormBody(form),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(function(data) {
            if (data.result == 'Error') {
                queryAll("input[name='password']").forEach(function(input) {
                    input.value = '';
                });

                var error = query('.login-modal__error');
                if (error) {
                    error.innerHTML = data.message;
                    fadeIn(error, 300);
                }
            } else if (data.payload && data.payload.redirect !== undefined) {
                window.location.assign(data.payload.redirect);
                return;
            }

            setButtonDisabled(submit, false);
        }).catch(function() {
            setButtonDisabled(submit, false);
        });

        return false;
    });

    onEach(queryAll('.forgot-password-modal__form'), 'submit', function(e) {
        e.preventDefault();

        var form = this;
        var submit = form.querySelector('[type="submit"]');
        setButtonDisabled(submit, true);

        fetchJson(form.getAttribute('action'), {
            method: 'POST',
            body: getFormBody(form),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(function(data) {
            if (data.payload && data.payload.message !== undefined) {
                queryAll("input[name='email']").forEach(function(input) {
                    input.value = '';
                });

                var message = query('.forgot-password-modal__form-message');
                if (message) {
                    message.innerHTML = data.payload.message;
                    fadeIn(message, 300);
                }
            }

            setButtonDisabled(submit, false);
        }).catch(function() {
            setButtonDisabled(submit, false);
        });

        return false;
    });

    // Pricing switcher
    onEach(queryAll('[data-action="switch-pricing"]'), 'click', function(event) {
        event.preventDefault();

        this.innerHTML = '<i class="fa fa-refresh fa-spin"></i>';

        fetch('/store/switch', {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(function() {
            location.reload();
        });
    });

    // Go back links
    onEach(queryAll('[data-action="go-back"]'), 'click', function(event) {
        event.preventDefault();
        window.history.back();
    });

    // Quick add loading icon
    onEach(queryAll('.quick-add-form'), 'submit', function() {
        var icon = this.querySelector('button[type="submit"] span');
        if (icon) {
            icon.innerHTML = '<i class="fa fa-circle-o-notch fa-spin"></i>';
        }
    });

    // Enable confirm buttons
    onEach(queryAll('a[data-confirm]'), 'click', function (event) {
        event.preventDefault();

        var trigger = this;
        var options = {
            no: query('#js-confirm-popup__action--no'),
            yes: query('#js-confirm-popup__action--yes')
        };
        var content = query('#confirm-popup');

        $.magnificPopup.open({
            type: 'inline',
            mainClass: 'mfp--outside mfp--confirm',
            closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close">' + svg.render('close') + '</button>',
            closeOnBgClick: false,
            items: {
                src: '.js-confirm-popup'
            },
            callbacks: {
                beforeOpen: function () {
                    var title = content && content.querySelector('.confirm-popup__title');

                    if (title) {
                        title.textContent = trigger.getAttribute('data-confirm');
                    }

                    if (options.yes) {
                        options.yes.setAttribute('href', trigger.getAttribute('href'));
                    }
                },
                open: function () {
                    if (options.no) {
                        options.no.onclick = function (e) {
                            e.preventDefault();
                            $.magnificPopup.close();
                        };
                    }
                }
            },
            fixedContentPos: true
        });
    });

    onEach(queryAll('.js-download-action-add'), 'click', function(e) {
        e.preventDefault();

        var current = this;
        var url = current.getAttribute('href');

        // Horrible hack to remove the word advertising from the URL so Adblock doesn't block it
        if (current.classList.contains('js-download-action-add--bundle') && url) {
            url = url.replace('advertising', 'ahash');
        }

        var extra = '';
        var partnerSubFilter = query('#partner-sub-filter');

        if (query('#partner-sub-filter_replace') && partnerSubFilter) {
            extra = '&sub=' + encodeURIComponent(partnerSubFilter.value);
        }

        if (url) {
            fetchJson(url + '?v=' + (+new Date()) + extra, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function(data) {
                if (current.classList.contains('js-download-action-add--all')) {
                    queryAll('.product-dl__list .js-download-action-add .media-list__action-label').forEach(function(label) {
                        label.textContent = globalTranslations.downloadAdded;
                    });
                    queryAll('.product-dl__list .js-download-action-add').forEach(function(link) {
                        link.classList.add('button--disabled');
                    });
                }

                // $('.download-action__status', current).removeClass('fa-plus').addClass('fa-check');
                var currentLabel = query('.media-list__action-label', current);
                if (currentLabel && currentLabel.textContent == globalTranslations.addToDownload) {
                    currentLabel.textContent = globalTranslations.downloadAdded;
                    current.classList.add('button--disabled');
                } else if (currentLabel && currentLabel.textContent == globalTranslations.addAllToDownload) {
                    currentLabel.textContent = globalTranslations.allDownloadsAdded;
                    current.classList.add('button--disabled');
                }
                current.setAttribute('href', '');
                current.style.cursor = 'default';

                // Sort out child files if it's a bundle - main and popup add folder
                // if (current.hasClass('js-download-action-add--bundle')) {
                //     current
                //         .parents('.product-dl-list__detail:first, .bundle-items__body:first')
                //         .find('.js-download-action-add .download-action__status')
                //         .removeClass('fa-plus')
                //         .addClass('fa-check')
                //         .parents('.download-action')
                //         .attr('href', '')
                //         .css('cursor', 'default')
                //         .find('.download-action__label')
                //         .text(globalTranslations.downloadAdded);
                // }
                // var itemsContainer = current.parents('.bundle-items:first');
                // Sort out bundle if it's a child file of a bundle - Popup
                // if (itemsContainer.length) {
                //     var items = itemsContainer.find('.bundle-items__item .js-download-action-add');
                //
                //     if (items.length == items.find('.fa-check').length) {
                //         itemsContainer
                //             .find('.js-download-action-add--bundle .download-action__status')
                //             .removeClass('fa-plus')
                //             .addClass('fa-check')
                //             .parents('.download-action')
                //             .attr('href', '')
                //             .css('cursor', 'default')
                //             .find('.download-action__label')
                //             .text(globalTranslations.downloadAdded);
                //     }
                // }
                var basketCount = query('.page-intro__basket_count');
                if (basketCount) {
                    basketCount.innerHTML = data.result.count;
                }
            });
        }
    });

    // Close notice
    onEach(queryAll('a[data-action="close-notice"]'), 'click', function(e) {
        e.preventDefault();

        document.body.classList.remove('has-notice-bar');
        fetch('/index/clear-notice-bar', {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
    });

    // Stock rollout
    onEach(queryAll('.product-stock__togglemore'), 'click', function() {
        if (this.classList.contains('product-stock__togglemore--inline')) {
            var parent = this.closest('.product-stock');
            if (parent) {
                parent.classList.add('product-stock--expanded');
            }
            this.remove();
        } else {
            var links = queryAll('.product-stock__togglemore');
            var rollouts = queryAll('.product-stock__rollout');
            var isHidden = rollouts.length > 0 && rollouts[0].classList.contains('product-stock__rollout--hidden');

            rollouts.forEach(function(rollout) {
                rollout.classList.toggle('product-stock__rollout--hidden', !isHidden);
                setDisplay(rollout, isHidden);
            });

            links.forEach(function(link) {
                link.textContent = link.getAttribute(isHidden ? 'data-labelless' : 'data-labelmore');
            });
        }
    });
});

var tippyConfig = {
    animation: 'fade',
    arrow: true,
    theme: 'astro',
    interactive: true
};

// Tooltips
tippy('[data-tooltip]', tippyConfig);

delegate(document, 'click', '[data-close-tooltip]', function() {
    var popper = this.closest('.tippy-popper');

    if (popper && popper._tippy) {
        popper._tippy.hide(0);
    }
});

window.addEventListener('scroll', function() {
    queryAll('.tippy-popper').forEach(function(v) {
        var instance = v._tippy;

        if (instance && instance.state.visible) {
            instance.popperInstance.disableEventListeners();
            instance.hide();
        }
    });
});

onEach(queryAll('[data-action="submit-search"]'), 'click', function(e) {
    e.preventDefault();

    var form = this.closest('form');
    if (form) {
        form.dispatchEvent(new Event('submit', {
            bubbles: true,
            cancelable: true
        }));
    }
});

delegate(document.body, 'click', '[data-ga-category]', function(e) {
    var link = this;
    var callback = function() {};
    var href = link.getAttribute('href');

    if (link.matches('a')
        && link.getAttribute('target') != '_blank'
        && href
        && href.charAt(0) != '#'
        && !link.hasAttribute('data-ga-no-redirect')
    ) {
        e.preventDefault();
        callback = function() {
            window.location.href = href;
        };
    }

    TRACKING.trackEvent(
        link.getAttribute('data-ga-category'),
        link.getAttribute('data-ga-action') || 'Click',
        link.getAttribute('data-ga-label') || href,
        0,
        callback
    );
});

var downloadsList = query('#js-downloads-list');
var downloadsListToggle = query('#js-toggle-downloads');

if (downloadsList && downloadsListToggle) {
    downloadsListToggle.addEventListener('click', function(e) {
        e.preventDefault();
        downloadsList.classList.toggle('downloads-list--closed');
        downloadsListToggle.remove();
    });
}

// var mobileNavOpenClass = 'header-nav__item--open';

var navToggle = queryAll('.js-toggle-nav');

onEach(navToggle, 'click', function() {
    var target = this.getAttribute('data-target');
    queryAll('.' + target).forEach(function(element) {
        element.classList.toggle(target + '--active');
    });
});

var subNavToggle = queryAll('.js-toggle-sub-nav');

onEach(subNavToggle, 'click', function() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
        this.classList.toggle('account-header__nav__item--hover');
    }
});

onEach(subNavToggle, 'mouseenter', function() {
    if (!window.matchMedia('(max-width: 1023px)').matches) {
        this.classList.add('account-header__nav__item--hover');
    }
});

onEach(subNavToggle, 'mouseleave', function() {
    if (!window.matchMedia('(max-width: 1023px)').matches) {
        this.classList.remove('account-header__nav__item--hover');
    }
});

// Need to target it explicilty for iOS
// $(document)
//     .on('click', '.header-nav--mobile .header-nav__item--has-sub-nav .header-nav__item__arrow', function(e) {
//         e.preventDefault();

//         var link = $(this),
//             navItem = link.parents('.header-nav__item:first');

//         navItem.toggleClass(mobileNavOpenClass);
//     });

// Stop smooth-scroll animation if the user starts interacting.
['wheel', 'mousedown', 'touchstart', 'keydown'].forEach(function(eventName) {
    window.addEventListener(eventName, function(event) {
        if (eventName !== 'keydown' || event.which > 0 || event.key) {
            stopWindowScrollAnimation();
        }
    }, {passive: true});
});

delegate(document, 'click', '.gallery__crosshair', function() {
    var crosshair = this;
    var container = crosshair.parentElement;
    var activeClass = 'gallery__crosshair--active';
    var active = crosshair.classList.contains(activeClass);

    if (active) {
        crosshair.classList.remove(activeClass);
        triggerCustomEvent(crosshair, 'crosshair.deactivated');
    } else {
        queryAll('.' + activeClass, container).forEach(function(activeCrosshair) {
            activeCrosshair.classList.remove(activeClass);
            triggerCustomEvent(activeCrosshair, 'crosshair.deactivated');
        });
        crosshair.classList.add(activeClass);
        triggerCustomEvent(crosshair, 'crosshair.activated');
    }
});

delegate(document, 'click', '[data-add-to-basket]', function(e) {
    e.preventDefault();

    var trigger = this;
    var target = '#add-to-basket-modal';
    var options = {
        close: query('#js-add-to-basket-close'),
        add: query('#js-add-to-basket-add'),
        quantity: query('#js-add-to-basket-quantity')
    };
    var content = query('.popup-content__container');

    if (trigger.hasAttribute('data-disabled')) {
        return false;
    }

    $.magnificPopup.open({
        type: 'inline',
        items: {src: target},
        mainClass: 'mfp--stock-levels',
        callbacks: {
            beforeOpen: function() {
                var stock = JSON.parse(trigger.getAttribute('data-stock'));
                var ukStockLabel = trigger.getAttribute('data-ukStockLabel');
                var bvMessaging = trigger.getAttribute('data-bv');
                var productName = content && content.querySelector('.product__name');
                var productSku = content && content.querySelector('.product__sku');
                var productFinish = content && content.querySelector('.product__finish');
                var productFinishLabel = productFinish && productFinish.querySelector('span:first-child');
                var productPrice = content && content.querySelector('.product__price');
                var productStock = content && content.querySelector('.product__stock');

                if (productName) {
                    productName.textContent = trigger.getAttribute('data-name');
                }

                if (productSku) {
                    productSku.textContent = trigger.getAttribute('data-sku');
                }

                if (trigger.getAttribute('data-finish')) {
                    setDisplay(productFinish, true);
                    if (productFinishLabel) {
                        productFinishLabel.textContent = trigger.getAttribute('data-finish');
                    }
                } else {
                    setDisplay(productFinish, false);
                }

                if (productPrice) {
                    productPrice.innerHTML = trigger.getAttribute('data-price');
                }

                if (productStock) {
                    productStock.innerHTML = getStockHtml(stock, ukStockLabel, bvMessaging);
                }

                if (options.add) {
                    options.add.classList.remove('button--disabled');
                }
                if (options.quantity) {
                    options.quantity.removeAttribute('disabled');
                }

                if (stock.length) {
                    if (options.add) {
                        options.add.setAttribute('href', trigger.getAttribute('data-addUrl'));
                    }
                } else {
                    if (options.add) {
                        options.add.classList.add('button--disabled');
                    }
                    if (options.quantity) {
                        options.quantity.setAttribute('disabled', true);
                    }
                }
            },
            open: function() {
                if (options.close) {
                    options.close.onclick = function(e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                    };
                }

                if (options.add) {
                    options.add.onclick = function(e) {
                        e.preventDefault();

                        if (options.add.classList.contains('button--disabled')) {
                            return;
                        }

                        fetchJson(trigger.getAttribute('data-addUrl') + '?qty=' + options.quantity.value, {
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest'
                            }
                        }).then(function(data) {
                            $.magnificPopup.close();
                            if (data.payload.upsellUrl) {
                                window.location = data.payload.upsellUrl;
                            } else {
                                var minibasket = query('#minibasket');
                                var minibasketMarker = query('#minibasket-marker');
                                var basketQtyDesktop = query('#basket-qty-desktop');
                                var basketQtyMobile = query('#basket-qty-mobile');

                                if (minibasket) {
                                    minibasket.innerHTML = data.payload.minibasket;
                                    minibasket.classList.add('mini-basket--show');
                                }
                                if (minibasketMarker) {
                                    minibasketMarker.classList.add('mini-basket-marker--show');
                                }
                                if (basketQtyDesktop) {
                                    basketQtyDesktop.innerHTML = data.payload.item_count;
                                    basketQtyDesktop.classList.remove('basket-link__text--hidden');
                                }
                                if (basketQtyMobile) {
                                    basketQtyMobile.innerHTML = data.payload.item_count;
                                    basketQtyMobile.classList.remove('basket-link__text--hidden');
                                }
                                TRACKING.trackAddProduct(data.payload);
                            }
                        });
                    };
                }
            }
        }
    });
});

var minibasket = query('#minibasket');

if (minibasket) {
    minibasket.addEventListener('click', function(e) {
        e.stopPropagation();
    });
}

document.addEventListener('click', function() {
    var minibasketEl = query('#minibasket');
    var minibasketMarker = query('#minibasket-marker');

    if (minibasketEl && minibasketEl.classList.contains('mini-basket--show')) {
        minibasketEl.classList.remove('mini-basket--show');
        if (minibasketMarker) {
            minibasketMarker.classList.remove('mini-basket-marker--show');
        }
    }
});

// $('.js-scroll-table').scrollTable();

var decorativeController,
    technicalController,
    loading = '<div class="product-listing-item__loading js-product-listing-item__loading"><div class="product-listing-item__loading-image"><img src="/images/loading.gif" alt=""></div></div>';

// Very quickly done, will need a refactor
delegate(document, 'click', '.js-styles__listing-items .js-product-listing-item__variant', function(e) {
    e.preventDefault();

    var link = this;
    var container = link.closest('.product-listing-item');

    if (!container) {
        return;
    }

    if (link.classList.contains('variants__item--active')) {
        window.location.href = link.getAttribute('href');
        return;
    }

    queryAll('.js-product-listing-item__variant', container).forEach(function(variant) {
        variant.classList.remove('variants__item--active');
    });

    link.classList.add('variants__item--active');

    if (decorativeController) {
        decorativeController.abort();
    }

    decorativeController = new AbortController();

    var overlayBlock = query('.js-product-listing-item__overlay-block', container);
    var badge = query('.js-product-listing-item__badge', container);
    var mto = query('.js-product-listing-item__mto', container);
    var charging = query('.js-product-listing-item__charging', container);
    var imageWrap = query('.js-product-listing-item__image-wrap', container);

    container.style.opacity = 0.4;
    setDisplay(overlayBlock, true);
    setDisplay(badge, false);
    setDisplay(mto, false);
    charging.classList.add('field--hidden');
    if (imageWrap) {
        imageWrap.insertAdjacentHTML('beforeend', loading);
    }

    fetchJson(buildUrl('/products/plp-data', {
        sku: link.getAttribute('data-sku')
    }), {
        signal: decorativeController.signal,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function(data) {
        if (data.message == 'Ok') {
            var code = query('.js-product-listing-item__code', container);
            var finish = query('.js-product-listing-item__finish', container);
            var linkEl = query('.js-product-listing-item__link', container);
            var image = query('.js-product-listing-item__image', container);
            var title = query('.js-product-listing-item__title', container);
            var stockOverlay = query('.product-listing-item__overlay-stock', container);
            var price = query('.js-product-listing-item__price', container);
            var form = query('.js-product-listing-item__form', container);
            var quickViewButton = query('[data-add-to-basket]', container);

            if (code) {
                code.textContent = data.result.sku;
            }

            if (finish) {
                finish.textContent = data.result.finish;
            }

            if (linkEl) {
                linkEl.setAttribute('href', data.result.url);
            }

            replaceImageHtml(image, data.result.image);

            if (title) {
                title.textContent = data.result.title;
            }

            if (data.result.is_new === true) {
                setDisplay(badge, true);
            }

            if (data.result.is_mto === true) {
                setDisplay(mto, true);
            }

            if (data.result.has_charging === true) {
                charging.classList.remove('field--hidden');
            }

            if (stockOverlay) {
                stockOverlay.innerHTML = data.result.stockOverlay;
            }

            if (data.result.price && price) {
                price.textContent = data.result.price.replace('&pound;', '£');
            }

            if (data.result.addUrl && form) {
                form.setAttribute('action', data.result.addUrl);
            }

            if (quickViewButton && data.result.stock) {
                if (data.result.stock.length) {
                    quickViewButton.setAttribute('data-name', data.result.title);
                    quickViewButton.setAttribute('data-finish', data.result.finish);
                    quickViewButton.setAttribute('data-sku', data.result.sku);
                    quickViewButton.setAttribute('data-stock', JSON.stringify(data.result.stock));
                    quickViewButton.setAttribute('data-price', data.result.price);
                    quickViewButton.setAttribute('data-addUrl', data.result.addUrl);
                    quickViewButton.innerHTML = '<span>' + globalTranslations.stockLevel + '</span>';
                    quickViewButton.classList.remove('button--disabled');
                    quickViewButton.removeAttribute('data-disabled');
                } else {
                    quickViewButton.removeAttribute('data-name');
                    quickViewButton.removeAttribute('data-finish');
                    quickViewButton.removeAttribute('data-sku');
                    quickViewButton.removeAttribute('data-stock');
                    quickViewButton.removeAttribute('data-price');
                    quickViewButton.removeAttribute('data-addUrl');
                    quickViewButton.innerHTML = '<span>' + globalTranslations.outOfStock + '</span>';
                    quickViewButton.classList.add('button--disabled');
                    quickViewButton.setAttribute('data-disabled', true);
                }
            }

            container.style.opacity = 1;
            setDisplay(overlayBlock, false);
            queryAll('.js-product-listing-item__loading', container).forEach(function(loader) {
                loader.remove();
            });
        }
    }).catch(function(error) {
        if (error.name !== 'AbortError') {
            container.style.opacity = 1;
            setDisplay(overlayBlock, false);
            queryAll('.js-product-listing-item__loading', container).forEach(function(loader) {
                loader.remove();
            });
        }
    });
});

delegate(document, 'click', '.js-styles__listing-items [data-variant-row]', function(e) {
    // If clicked the checkbox carry on as normal
    if (e.target.closest('.product-listing-item__checkbox')) {
        return;
    }

    e.preventDefault();

    var row = this;
    var container = row.closest('.listing-item');

    if (!container) {
        return;
    }

    if (row.classList.contains('listing-item__table__data-row--active')) {
        window.location.href = row.getAttribute('data-url');
        return;
    }

    queryAll('.listing-item__table__data-row--active', container).forEach(function(activeRow) {
        activeRow.classList.remove('listing-item__table__data-row--active');
    });

    row.classList.add('listing-item__table__data-row--active');

    if (technicalController) {
        technicalController.abort();
    }

    technicalController = new AbortController();

    var preview = query('.listing-item__preview', container);
    var badge = query('.listing-item__badge', container);
    var price = query('.listing-item__price', container);

    if (preview) {
        preview.style.opacity = 0.4;
        preview.insertAdjacentHTML('beforeend', loading);
    }
    setDisplay(badge, false);
    setDisplay(price, false);

    fetchJson(buildUrl('/products/plp-data', {
        sku: row.getAttribute('data-sku')
    }), {
        signal: technicalController.signal,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function(data) {
        if (data.message == 'Ok') {
            var infoLink = query('.listing-item__info a', container);
            var thumbnail = query('.listing-item__thumbnail', container);
            var sku = query('.listing-item__sku', container);
            var titleLink = query('.listing-item__title a', container);

            if (infoLink) {
                infoLink.setAttribute('href', data.result.url);
            }

            replaceImageHtml(thumbnail, data.result.image);

            if (data.result.is_new === true) {
                setDisplay(badge, true);
            }

            if (sku) {
                sku.textContent = data.result.sku;
            }

            if (titleLink) {
                titleLink.textContent = data.result.title;
                titleLink.setAttribute('href', data.result.url);
            }

            if (data.result.price && price) {
                price.textContent = data.result.price.replace('&pound;', '£');
                setDisplay(price, true);
            }

            if (preview) {
                preview.style.opacity = 1;
            }
            queryAll('.js-product-listing-item__loading', container).forEach(function(loader) {
                loader.remove();
            });
        }
    }).catch(function(error) {
        if (error.name !== 'AbortError') {
            if (preview) {
                preview.style.opacity = 1;
            }
            queryAll('.js-product-listing-item__loading', container).forEach(function(loader) {
                loader.remove();
            });
        }
    });
});

var breakpoint = new Breakpoint();

delegate(document, 'click', '.js-product-listing-item__image-wrap', function() {
    if (breakpoint.matches('tablet') && this.getAttribute('data-href')) {
        window.location = this.getAttribute('data-href');
    }
});

delegate(document, 'click', '.js-ajax-reload', function(e) {
    e.preventDefault();

    var link = this;
    var results = link.getAttribute('data-results');
    var resultsEls = queryAll(results);
    var additional = link.getAttribute('data-additional');
    var additionalEls = additional ? queryAll(additional) : [];

    history.pushState({}, null, link.href);

    ajax_response++;

    resultsEls.forEach(function(result) {
        result.classList.add('busy', 'ajax-results');
    });

    fetchText(buildUrl(link.href, {
        request: ajax_response
    }), {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function(response) {
        var html = parseHtmlDocument(response);
        var responseEls = queryAll(results, html);

        if (responseEls.length === 0) {
            console.log('Response not found');
            return;
        }

        if (parseInt(responseEls[0].getAttribute('data-request'), 10) !== ajax_response) {
            // this is not the current request, ignore the response
            return;
        }

        function finished(newDocument) {
            var newResults = queryAll(results, newDocument);

            resultsEls.forEach(function(result, index) {
                result.classList.remove('busy');
                result.innerHTML = newResults[index] ? newResults[index].innerHTML : '';
            });

            if (additionalEls.length > 0) {
                var additionalResponse = queryAll(additional, newDocument);
                additionalEls.forEach(function(item, index) {
                    item.innerHTML = additionalResponse[index] ? additionalResponse[index].innerHTML : '';
                });
            }
        }

        var images = [];
        responseEls.forEach(function(responseEl) {
            images = images.concat(queryAll('img', responseEl));
        });

        if (images.length === 0) {
            finished(html);
        } else {
            waitForImages(images).then(function() {
                finished(html);
            });
        }
    }).catch(function() {
        resultsEls.forEach(function(result) {
            result.classList.remove('busy');
        });
    });
});

delegate(document, 'click', '.js-selected', function(e) {
    e.preventDefault();

    var className = this.getAttribute('data-selected');

    this.classList.add(className);

    if (this.parentElement) {
        toArray(this.parentElement.children).forEach(function(sibling) {
            if (sibling !== this) {
                sibling.classList.remove(className);
            }
        }, this);
    }
});

window
    .onpopstate = function(e) {
        // Should never happen
        if (!e.state) {
            return;
        }

        if (e.state.view) {
            switchListingType(e.state.view, e.state.styleId, true);
        }

        if (!e.state.styleId) {
            animateWindowScrollTo(0, 1000);
        }
    }

// This markup is also duplicated in partials/product/stock-info.html
var getStockHtml = function(stock, ukStockLabel, bvMessaging) {
        var html = '';
        var showBvMessaging = false;

        if (stock.length) {
            stock.forEach(function(item) {
                html += '<div class="product-stock__item';
                html += item.type == 'stock' ? ' product-stock__item--highlight' : '';
                html += '">';

                if (item.type == 'stock') {
                    html += '<div>' + item.quantity + ' ' + (ukStockLabel === 'true' ? globalTranslations.ukStock : globalTranslations.inStock) + '</div>';
                } else {
                    var asterisk = '';
                    if (bvMessaging === 'true' && item.source == 'IC001') {
                        asterisk = '<span>*</span>';
                        showBvMessaging = true;
                    }
                    html += '<div>' + item.quantity + ' ' + globalTranslations.due + ' ' + item.pretty_date + asterisk + '</div>';
                }

                html += '</div>';
            });

            if (showBvMessaging) {
                html += '<div class="product-stock__message"><p>* ' + globalTranslations.bvStockMessaging + '</p></div>';
            }
        } else {
            html += '<div class="product-stock__item">' + globalTranslations.outOfStock + '</div>';
        }

        return '<div class="product-info">' + html + '</div>';
    }

onReady(function() {
    var outerwraps = queryAll('.tabs.detail__tabs');
    var innerwraps = queryAll('.tabs__wrap');

    updateFadedEdges();

    window.addEventListener('resize', updateFadedEdges);
    onEach(innerwraps, 'scroll', updateFadedEdges);

    function updateFadedEdges() {
        outerwraps.forEach(function(wrap, index) {
            var innerwrap = innerwraps[index];

            if (!innerwrap) {
                return;
            }

            var classLeft = wrap.classList.contains('tabs--hightlight') ? 'tabs--highlighted--overflow-left' : 'tabs--overflow-left';
            var classRight = wrap.classList.contains('tabs--hightlight') ? 'tabs--highlighted--overflow-right' : 'tabs--overflow-right';
            var rightOffset = wrap.clientWidth - innerwrap.scrollWidth;

            wrap.classList.toggle(classLeft, innerwrap.scrollLeft > 0);
            wrap.classList.toggle(classRight, innerwrap.scrollLeft < Math.abs(rightOffset));
        });
    }
});

onReady(function() {
    var slug = '/types';
    var viewingTypes = window.location.pathname.indexOf(slug) > -1;
    var browse = query('.js-product-browse');
    var buttons = browse ? queryAll('.product-browse__button', browse) : [];
    var discontinued = query('#discontinued');

    checkBrowseBy(buttons[viewingTypes ? 1 : 0]);

    onEach(buttons, 'click', function(e) {
        e.preventDefault();
        checkBrowseBy(this);
    });

    function checkBrowseBy(el) {
        if (!el || !browse) {
            return;
        }

        var visible = el.getAttribute('data-browse-by');
        browse.setAttribute('data-browsing-by', visible);
    }

    if (discontinued) {
        discontinued.addEventListener('change', function() {
            var parts = URN.parts(document.location.href);

            if (this.checked) {
                parts.querystring = URN.setQueryStringParam(parts.querystring, 'discontinued', '1');
                document.location = URN.build(parts);
            } else {
                parts.querystring = URN.setQueryStringParam(parts.querystring, 'discontinued', null);
                document.location = URN.build(parts);
            }
        });
    }
});

// Open external links in a new tab
delegate(document, 'click', 'a.external', function(e) {
    e.preventDefault();
    window.open(this.getAttribute('href'));
});

String.prototype._moustache = function (data) {
    var s = this.toString();
    for (var i in data) {
        s = s.toString().replace('{' + i + '}', data[i]);
    }

    s = s.replace(/(\{.+?\})/g, '');

    return s;
};

onEach(queryAll('.js-accordion__toggle'), 'click', function() {
    var accordion = this.parentElement;

    if (!accordion || accordion.classList.contains('accordion--disabled')) {
        return;
    }

    if (accordion.classList.contains('accordion--active')) {
        deactivateAccordion(accordion);
    } else {
        var group = accordion.getAttribute('data-accordion-group');

        if (group) {
            queryAll('[data-accordion-group="' + group + '"]').forEach(function(groupAccordion) {
                if (groupAccordion.classList.contains('accordion--active')) {
                    deactivateAccordion(groupAccordion);
                }
            });
        }

        activateAccordion(accordion);
    }
});

function activateAccordion(element) {
    var accordion = element && element.jquery ? element[0] : element;
    var wrapper = query('.accordion__wrapper', accordion);
    var content = query('.accordion__content', accordion);

    if (!accordion || !wrapper || !content) {
        return;
    }

    var contentStyle = window.getComputedStyle(content);
    wrapper.style.maxHeight = content.offsetHeight + parseInt(contentStyle.paddingBottom, 10) + 'px';
    accordion.classList.add('accordion--active');
}

function deactivateAccordion(element) {
    var accordion = element && element.jquery ? element[0] : element;
    var wrapper = query('.accordion__wrapper', accordion);

    if (!accordion || !wrapper) {
        return;
    }

    wrapper.removeAttribute('style');
    accordion.classList.remove('accordion--active');
}

function updateAccordion(el) {
    activateAccordion(el && el.jquery ? el[0] : el);
}

// If the accordion should be disabled for desktop, then we need to check the breakpoint on page load and on resize
var accordionBreakpoint = new Breakpoint();

function updateTabletAccordions(matchesTablet) {
    queryAll('.accordion.accordion--tablet').forEach(function(accordion) {
        accordion.classList.toggle('accordion--disabled', !matchesTablet);
    });
}

updateTabletAccordions(accordionBreakpoint.matches('tablet'));

accordionBreakpoint.matchMedia('tablet').addListener(function(e) {
    updateTabletAccordions(e.matches);
});

delegate(document, 'click', 'a[href^="#"]', function (e) {
    if (this.hasAttribute('data-ignore-scroll')) {
        return;
    }

    var href = this.getAttribute('href');
    if (
        href != '#'
        && !this.closest('.slick-slide')
        && !this.classList.contains('cookie-preferences__nav-link')
        && !this.classList.contains('site-switch')
    ) {
        var target;

        try {
            target = query(href);
        } catch (error) {
            return;
        }

        if (target) {
            e.preventDefault();
            scrollToEl(target);
        }
    }
});

function scrollToEl(el) {
    var target = el && el.jquery ? el[0] : el;

    if (target) {
        var scrollDuration = 300;
        var offset = 0;

        var items = [
            query('#admin-bar'),
            query('#debug-bar'),
            query('.header'),
            query('.notice-bar')
        ];

        var scrollTop = Math.round(target.getBoundingClientRect().top + window.pageYOffset - offset);

        // if (window.matchMedia('(max-width: 550px)').matches) {
        for (var i = 0; i < items.length; i++) {
            if (items[i]) {
                scrollTop -= getOuterHeight(items[i]);
            }
        }
        // }

        animateWindowScrollTo(scrollTop, scrollDuration);

        target.dispatchEvent(new Event('click', {
            bubbles: true
        }));
    }
}

onEach(queryAll('.js-notice-show-info'), 'click', function () {
    $.magnificPopup.open({
        type: 'inline',
        mainClass: 'mfp--notice mfp-fade',
        removalDelay: 200,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close">' + svg.render('close') + '</button>',
        items: {
            src: '.js-notice'
        },
        fixedContentPos: true
    });
});

onEach(queryAll('.js-bv-stock-overlay'), 'click', function(e) {
    e.preventDefault();

    $.magnificPopup.open({
        type: 'inline',
        mainClass: 'mfp--pdp-overlay mfp-fade',
        removalDelay: 200,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close">' + svg.render('close') + '</button>',
        items: {
            src: '.js-bv-overlay'
        },
        fixedContentPos: true
    });
});

onEach(queryAll('.js-no-product-notice'), 'click', function(e) {
    e.preventDefault();

    var trigger = this;
    var options = {
        close: query('.js-plp-overlay-close'),
        viewProfessional: query('.js-plp-overlay-view-professional'),
        title: query('.js-plp-overlay-title')
    };

    $.magnificPopup.open({
        type: 'inline',
        mainClass: 'mfp--plp-overlay mfp-fade',
        removalDelay: 200,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close">' + svg.render('close') + '</button>',
        items: {
            src: '.js-plp-overlay'
        },
        fixedContentPos: true,
        callbacks: {
            beforeOpen: function () {
                if (options.close) {
                    options.close.onclick = function (e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                    };
                }

                if (options.viewProfessional) {
                    options.viewProfessional.setAttribute('href', trigger.getAttribute('href'));
                }
                if (options.title) {
                    options.title.innerHTML = trigger.getAttribute('data-overlay-title');
                }
            }
        }
    });
});

window.realignListingAction = function() {
    queryAll('.js-listing-item-group').forEach(function(group) {
        var action = query('.js-listing-item__action[data-id="' + group.getAttribute('data-id') + '"]');

        if (action) {
            var height = group.getBoundingClientRect().height;
            var actionHeight = action.getBoundingClientRect().height;
            var diff = height - actionHeight;

            action.style.paddingTop = diff / 2 + 'px';
            action.style.paddingBottom = diff / 2 + 'px';
        }
    });
};

window.checkScrollbarWidth = function() {
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
};

var resize;

window.addEventListener('resize', function() {
    clearTimeout(resize);
    resize = setTimeout(function() {
        window.realignListingAction();
        window.checkScrollbarWidth();
    }, 100);
});

window.addEventListener('load', function() {
    window.realignListingAction();
    window.checkScrollbarWidth();
});

// $('.site-switch').magnificPopup({
//     type: 'inline',
//     mainClass: 'mfp--site-switch mfp-fade',
//     removalDelay: 200,
//     showCloseBtn: false
// });
//
// $(document).on('click', '.js-site-switch-close', function(e) {
//     $.magnificPopup.close();
// });

function resizeProjectBlock() {
    queryAll('.block__wrap--project').forEach(function(block) {
        var header = query('.block__image--project', block);
        var content = query('.block-content--project', block);

        if (!header || !content) {
            return;
        }

        var contentStyle = window.getComputedStyle(content);
        var headerStyle = window.getComputedStyle(header);
        var heightDiff = content.getBoundingClientRect().height - header.getBoundingClientRect().height;
        var margins = parseInt(contentStyle.marginTop, 10) +
            parseInt(contentStyle.marginBottom, 10) -
            parseInt(headerStyle.marginBottom, 10);

        header.style.marginBottom = heightDiff + margins + 'px';
    });
}

window.addEventListener('load', resizeProjectBlock);
window.addEventListener('resize', resizeProjectBlock);

(function () {
    const accordionHeaders = document.querySelectorAll('[data-accordion-header]');
    const mobileOnlyAccordion = document.querySelector('[data-mobile-accordion]');

    accordionHeaders.forEach(accordionHeader => {

        let target = accordionHeader.parentElement.nextElementSibling;

        if (mobileOnlyAccordion) {
            if (window.matchMedia('(max-width: 1023px)').matches) {
                target.hidden = true;
            } else {
                target.hidden = false;
            }
        } else {
            target.hidden = true;
        }

        accordionHeader.addEventListener('click', () => {

            let expanded = accordionHeader.getAttribute('aria-expanded') === 'true' || false;
            accordionHeader.setAttribute('aria-expanded', !expanded);
            target.hidden = expanded;
        })

        window.addEventListener('resize', () => {
            if (mobileOnlyAccordion) {
                if (window.matchMedia('(max-width: 1023px)').matches && mobileOnlyAccordion) {
                    target.hidden = true;
                } else {
                    target.hidden = false;
                }
            }
        })
    })
})();

delegate(document, 'click', '.js-compatible-item .js-compatible-item__variant', function(e) {
    e.preventDefault();

    var variant = this;
    var container = variant.closest('.js-compatible-item');

    if (!container) {
        return;
    }

    if (variant.classList.contains('variants__item--active')) {
        window.location.href = variant.getAttribute('href');
        return;
    }

    queryAll('.js-compatible-item__variant', container).forEach(function(item) {
        item.classList.remove('variants__item--active');
    });

    variant.classList.add('variants__item--active');

    if (decorativeController) {
        decorativeController.abort();
    }

    decorativeController = new AbortController();

    container.style.opacity = 0.4;

    fetchJson(buildUrl('/products/plp-data', {
        sku: variant.getAttribute('data-sku')
    }), {
        signal: decorativeController.signal,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function(data) {
        if (data.message == 'Ok') {
            var meta = query('.compatible-item__meta', container);
            var link = query('.js-compatible-item__link', container);
            var image = query('.compatible-item__image > figure', container);
            var title = query('.compatible-item__title', container);
            var price = query('.compatible-item__price', container);

            if (meta) {
                meta.textContent = data.result.sku;
            }

            if (link) {
                link.setAttribute('href', data.result.url);
            }

            replaceImageHtml(image, data.result.image);

            if (title) {
                title.textContent = data.result.title;
            }

            if (data.result.price && price) {
                price.textContent = data.result.price.replace('&pound;', '£');
            }

            container.style.opacity = 1;
        }
    }).catch(function(error) {
        if (error.name !== 'AbortError') {
            container.style.opacity = 1;
        }
    });
});

/*
* These need to be hooked up correctly for the order import
*/

window.fileSelected = function(ev, button, value) {
    var buttonElement = button && button.jquery ? button[0] : button;

    if (!buttonElement) {
        return;
    }

    if (!value) {
        buttonElement.textContent = 'choose file';
    } else {
        queryAll('.field--submit').forEach(function(field) {
            field.classList.add('field--submit--active');
        });
        var filename = value.split('\\').pop();
        buttonElement.textContent = filename;
    }
};

window.dropHandler = function(ev) {
    console.log('File(s) dropped');

    var input = document.querySelector('#partner_import_uploaded_file');

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    input.files = ev.dataTransfer.files;
    input.dispatchEvent(new Event('change', {
        bubbles: true
    }));
};

window.dragOverHandler = function(ev) {
  console.log('File(s) in drop zone');

  // Prevent default behavior (Prevent file from being opened)
  ev.preventDefault();
}

/**
* We need to remove the local storage attribute here if we navigate away from the import page
* See open-accordion.js
*/

if (!window.location.href.includes('/imports/review')) {
    localStorage.removeItem('accordion');
}

// Add PDP configuration pop

(() => {
    const configureButton = document.querySelector('[data-configure]');

    if (!configureButton) {
        return;
    }

    configureButton.addEventListener('click', () => {
        $.magnificPopup.open({
            type: 'inline',
            mainClass: 'mfp--pdp-configure-popup mfp-fade',
            removalDelay: 200,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close">' + svg.render('close') + '</button>',
            items: {
                src: '.js-pdp-configure'
            },
            fixedContentPos: true,
            callbacks: {
                open: function() {
                    const scrollContainer = this.wrap[0];
                    
                    if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
                        scrollContainer.classList.add('mfp--has-scroll');
                    }
                }
            }
        });  
    });
})();

// Add PDP lamp pop

(() => {
    const addLampButton = document.querySelector('[data-add-lamp]');

    if (!addLampButton) {
        return;
    }

    addLampButton.addEventListener('click', () => {
        $.magnificPopup.open({
            type: 'inline',
            mainClass: 'mfp--pdp-configure-popup mfp-fade',
            removalDelay: 200,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close">' + svg.render('close') + '</button>',
            items: {
                src: '.js-pdp-add-lamp'
            },
            fixedContentPos: true,
            callbacks: {
                open: function() {
                    const scrollContainer = this.wrap[0];
                    
                    if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
                        scrollContainer.classList.add('mfp--has-scroll');
                    }
                }
            }
        });  
    });
})();
